import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";

export const getListDocumnetArchiveRequestClassification = (async (searchString, orderBy) => await http({
    url: ENDPOINTS.archive.documentArchiveRequestClassification.browse,
    method: 'get',
    params: {
        searchString: searchString,
        orderBy: orderBy
    }
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)

export const deleteDocumnetArchiveRequestClassification =  (id) =>  http({
    url: ENDPOINTS.archive.documentArchiveRequestClassification.browse,
    method: 'delete',
    params: {Id : id}

}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject( err);
})


export const getDocumnetArchiveRequestClassification = (async (id) => await http({
    url: ENDPOINTS.archive.documentArchiveRequestClassification.load,
    method: 'get',
    params: {Id : id}
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)

export const postDocumnetArchiveRequestClassification = (data) => http({
    url: ENDPOINTS.archive.documentArchiveRequestClassification.browse,
    
    method: 'post',
    data:data
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})


export const putDocumnetArchiveRequestClassification = (data) => http({
    url: ENDPOINTS.archive.documentArchiveRequestClassification.browse,
    method: 'put',
    data:data
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

